import { useFormikContext } from "formik";
import { Col, Row } from "reactstrap";
import { Checkbox, Radio, RadioGroup } from "rsuite";
import { BankAccountDto, PaymentTypeDto } from "../../redux/system/type";
import { formProps } from ".";
import { Input, InputNumber } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import { useEffect, useState } from "react";
import AgreementModal from "./agreementModal";
import { getBankaccounts } from "../../redux/system/saga";

const Step2 = ({ paymentTypes }: { paymentTypes: PaymentTypeDto[] }) => {
  const { setFieldValue, handleBlur, touched, values, errors, handleChange } =
    useFormikContext<formProps>();
  const t = useSelector(getLocalization);
  const [show, setShow] = useState(false);
  const [bankaccounts, setBankAccounts] = useState<BankAccountDto[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getBankaccounts({
        payload: {
          onSuccess: (message, payload) => {
            setBankAccounts(payload);
          },
          onError: () => {},
        },
      })
    );
  }, [dispatch]);
  return (
    <div>
      {<AgreementModal open={show} setOpen={setShow} />}
      <Row className="mb-4">
        <Col>
          <RadioGroup
            className="mb-2"
            style={{ marginInlineStart: -10 }}
            value={values.PaymentTypeId}
            onChange={(value) => setFieldValue("PaymentTypeId", value)}
          >
            <div className="d-flex">
              {paymentTypes
                .filter((x) => x.EnumId === 1 || x.EnumId === 2)
                .map((x) => (
                  <Radio key={x.EnumId} value={x.EnumId}>
                    <span className="fw-bold f-capitalize">{x.Name}</span>
                  </Radio>
                ))}
            </div>
          </RadioGroup>
        </Col>
      </Row>
      <Row>
        {values.PaymentTypeId === 1 && (
          <>
            <Col md={12}>
              <Row>
                <Col md={12}>
                  <Input
                    placeholder={t.getString("Full Name") + "*"}
                    onChange={handleChange("CreateCardDto.FullName")}
                    onBlur={handleBlur("CreateCardDto.FullName")}
                    error={errors.CreateCardDto?.FullName}
                    touched={touched.CreateCardDto?.FullName}
                    value={values.CreateCardDto?.FullName}
                  />
                </Col>
                <Col md={12}>
                  <InputNumber
                    min={0}
                    value={values.CreateCardDto.CardNumber}
                    noarrow
                    scrollable={false}
                    onChange={(value) =>
                      value.toString().length <= 16 &&
                      setFieldValue("CreateCardDto.CardNumber", value)
                    }
                    placeholder={t.getString(`Card Number`) + "*"}
                    onBlur={handleBlur("CreateCardDto.CardNumber")}
                    error={errors.CreateCardDto?.CardNumber}
                    touched={touched.CreateCardDto?.CardNumber}
                  />
                </Col>
                <Col md={4}>
                  <InputNumber
                    min={0}
                    max={12}
                    noarrow
                    value={values.CreateCardDto.Month}
                    scrollable={false}
                    onChange={(value) =>
                      value.toString().length <= 2 &&
                      setFieldValue("CreateCardDto.Month", value)
                    }
                    placeholder={t.getString("Month") + "*"}
                    onBlur={handleBlur("CreateCardDto.Month")}
                    error={errors.CreateCardDto?.Month}
                    touched={touched.CreateCardDto?.Month}
                  />
                </Col>
                <Col md={4}>
                  <InputNumber
                    noarrow
                    scrollable={false}
                    min={0}
                    placeholder={t.getString(`Year`) + "*"}
                    value={values.CreateCardDto.Years}
                    touched={touched.CreateCardDto?.Years}
                    onChange={(value) =>
                      value.toString().length <= 4 &&
                      setFieldValue("CreateCardDto.Years", value)
                    }
                    onBlur={handleBlur("CreateCardDto.Years")}
                    error={errors.CreateCardDto?.Years}
                  />
                </Col>
                <Col md={4}>
                  <InputNumber
                    noarrow
                    value={values.CreateCardDto.Cvc}
                    touched={touched.CreateCardDto?.Cvc}
                    scrollable={false}
                    min={0}
                    onChange={(value) =>
                      value.toString().length <= 3 &&
                      setFieldValue("CreateCardDto.Cvc", value)
                    }
                    placeholder={"CVC" + "*"}
                    onBlur={handleBlur("CreateCardDto.Cvc")}
                    error={errors.CreateCardDto?.Cvc}
                  />
                </Col>
              </Row>
            </Col>
          </>
        )}
        {values.PaymentTypeId === 2 && (
          <Col sm="12 ">
            <p className="fw-bold">{"Bank Accounts"}</p>{" "}
            {bankaccounts.map((x) => (
              <div
                key={x.Id}
                className="border-secondary p-2"
                style={{
                  backgroundColor: "#F4F7FA",
                  borderRadius: 3,
                }}
              >
                {`${x.BankName},${t.getString("Account No")} : ${
                  x.AccountNumber
                } - ${x.OwnerName}(IBAN: ${x.Iban})`}
              </div>
            ))}
          </Col>
        )}
        {/* <Checkbox
          checked={values.isSecurity}
          onChange={(value, checked) => setFieldValue("isSecurity", checked)}
        >
          <label htmlFor={"isSecurity"}>3D SECURITY KULLAN</label>
        </Checkbox> */}
        <div className=" my-2" style={{ left: "-8px" }}>
          <Checkbox
            checked={values.isAccept}
            onChange={(value, checked) => setFieldValue("isAccept", checked)}
          >
            <label
              onClick={() => setShow(true)}
              className={
                errors.isAccept && touched.isAccept
                  ? "errorInput customlabel"
                  : "customlabel"
              }
              htmlFor={"isAccept"}
            >
              {t.getString(
                "I accept the terms of the distance selling contract"
              )}
            </label>
          </Checkbox>
          {errors.isAccept && touched.isAccept && (
            <div className="errorInfo text-danger" style={{ fontSize: 10 }}>
              *{errors.isAccept}
            </div>
          )}
        </div>
      </Row>
    </div>
  );
};
export default Step2;
